import { Box, Paper, PaperProps } from "@mui/material";
import { ReactNode } from "react";
import { NAVBAR_HEIGHT } from "@/constants/nav-bar-constant";
type ElevatedPaperProps = {
  children: ReactNode;
  defaultSetting?: boolean;
} & PaperProps;

const ElevatedPaper = ({
  children,
  defaultSetting = true,
  ...others
}: ElevatedPaperProps) => (
  <Box
    sx={{
      height: `calc(100svh - ${NAVBAR_HEIGHT})`,
      padding: "14px",
    }}
  >
    <Paper
      sx={defaultSetting ? DEFAULT_STYLE : others.sx}
      elevation={6}
      {...others}
    >
      {children}
    </Paper>
  </Box>
);

export default ElevatedPaper;

export const DEFAULT_STYLE = {
  // margin: "12px",
  padding: "10px 16px 0px 16px",
  height: "100%",
  // Keeps a mis-sized child from painting outside the card.
  overflow: "hidden",
};
